import Auth from '@/utils/Auth'

export default {
    name: 'AppMain',

    render() {
        return (
            <div class='yt-main-container'>
                <div class='yt-main' style={`${!Auth.isLogin() ? 'height: calc(100% - 74px);' : ''}`}>
                    <transition name='fade-transform' mode='out-in'>
                        {
                            this.$route.meta.noCache
                                ? <router-view />
                                : <keep-alive><router-view /></keep-alive>
                        }
                    </transition>
                </div>
            </div>
        )
    }
}
